import type { FC } from 'react';
import { useContext } from 'react';
import type { Theme } from '@material-ui/core/styles';
import {
  makeStyles, createStyles, lighten,
} from '@material-ui/core/styles';
import {
  Grid, Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import NavigationNestedLink from './NavigationNestedLink';
import type { NavLink } from './NavigationTypes';
import { EmployeeContext } from '../global/EmployeeProvider';

interface NavigationLinkProps {
  linkProp: Array<NavLink>,
  itemSize: number,
  linkOnClickProp: () => void,
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  linkHeader: {
    color: lighten(theme.palette.primary.main, 0.25),
    letterSpacing: '2px',
  },
  link: {
    color: theme.palette.common.white,
    marginBottom: '0.75rem',
  },
  reactRouterLink: {
    textDecoration: 'none',
  },
}));

const NavigationLinks: FC<NavigationLinkProps> = ({
  linkProp,
  itemSize,
  linkOnClickProp,
}) => {
  const classes = useStyles();
  const EmployeeInformation = useContext(EmployeeContext);

  const LinkMap = (
    linkProp.map((linkItem: NavLink) => {
      if (linkItem.nestedLinks) {
        return <NavigationNestedLink linkOnClickProp={linkOnClickProp} linkProp={linkItem} />;
      }
      if ((linkItem.requiredRole || linkItem.requiredDepartment || linkItem.requiredJobFunction)
        && (EmployeeInformation.employeeInfo?.filter((e) => (e?.department === linkItem.requiredDepartment || e?.role === 'Executive'))).length === 0
        && (EmployeeInformation.employeeInfo?.filter((e) => (e?.role === linkItem.requiredRole || e?.role === 'Executive'))).length === 0
        && EmployeeInformation.employeeInfo?.filter((e) => (
          (linkItem?.requiredJobFunction && linkItem?.requiredJobFunction?.findIndex((jf) => jf === e.jobFunction) !== -1) || e?.role === 'Executive')).length === 0
      ) { return (<></>); }
      return (
        <Grid item xs={(itemSize === 6) ? 6 : 12} key={linkItem.displayText}>
          <Link
            id={`${linkItem.displayText.replace(' ', '-').toLowerCase()}`}
            to={linkItem.link}
            className={classes.reactRouterLink}
            onClick={(e) => {
              if (e.currentTarget instanceof HTMLElement) {
                e.currentTarget.blur();
                linkOnClickProp();
              }
            }}
          >
            <Typography className={classes.link}>{linkItem.displayText}</Typography>
          </Link>
        </Grid>
      );
    }));

  return (
    <>
      {LinkMap}
    </>
  );
};
export default NavigationLinks;
